import ApiHelper from '../ApiHelper.js';

const API_URL = "/api/generative-ai";

export default {
    createProjectWithAi: function(
        ownerId,
        portfolioId,
        order,
        selectedSections,
        userPrompt,
        designSettings,
        selectedMockup,
        defaultCaseStudyValues,
        defaultThumbnailData,
        uploadedImageBlob,
        uploadedCroppedImageBlob,
        fileName
    ) {
        const formData = new FormData();
        formData.append('ownerId', ownerId);
        formData.append('portfolioId', portfolioId);
        formData.append('order', order);
        formData.append('selectedSections', selectedSections);
        formData.append('userPrompt', userPrompt);
        formData.append('selectedMockup', selectedMockup);
        formData.append('designSettings', new Blob([JSON.stringify(designSettings)], { type: 'application/json' }));
        formData.append('defaultCaseStudyValues', new Blob([JSON.stringify(defaultCaseStudyValues)], { type: 'application/json' }));
        formData.append('defaultThumbnailData', new Blob([JSON.stringify(defaultThumbnailData)], { type: 'application/json' }));

        if (uploadedImageBlob) {
            formData.append('imageFile', uploadedImageBlob, fileName);
        }

        if(uploadedCroppedImageBlob) {
            formData.append('croppedImageFile', uploadedCroppedImageBlob, fileName);
        }

        return ApiHelper.post(`${API_URL}/generate/case-study`, formData);
    },
    enhanceText(
        content,
        userPrompt,
        enhanceType,
        feature
    ) {
        const data = {
            userPrompt:userPrompt,
            enhanceType: enhanceType,
            feature:feature,
            content:content
        }
        return ApiHelper.post(`${API_URL}/enhance`, data);
    },
    generateJobFitCheck: function({
          jobTitle,
          jobCompany,
          jobDescription,
          ownerId,
          portfolioShortId
    }) {
        return ApiHelper.post(`${API_URL}/generate/job-fit-checker`, {
            jobTitle,
            jobCompany,
            jobDescription,
            ownerId,
            portfolioShortId
        });
    },
}
